<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>签到区间管理</span>
          <clear-cache-apply />
          <sync-data />
        </div>

        <template>
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="周期" name="weekly">
              <el-table :data="formData['weekly']" border stripe>
                <el-table-column prop="ID" label="ID">
                  <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="等级范围">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.min_level" style="width: 42%;" placeholder="最小等级" />
                    <span style="margin: 0px 2px">-</span>
                    <el-input v-model.number="scope.row.max_level" style="width: 42%" placeholder="最小等级" />
                  </template>
                </el-table-column>
                <el-table-column v-for="item in days" :key="'weekly'+item" :label="'第'+item+'天'">
                  <template slot-scope="scope">
                    <Reward :value="scope.row.prize_json[item - 1].prize" :read-only="true" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[scope.$index].visible = true">配置</el-button>
                    <el-drawer :before-close="(d)=>{return handleClose(d, scope.$index)}" title="奖励配置" size="40%" :visible="visibleArr[scope.$index].visible">
                      <el-form :inline="true">
                        <el-row v-for="(p,i) in scope.row.prize_json" :key="i">
                          <el-form-item label="第几天" style="margin-top: 10px;">
                            <el-input v-model.number="p.day" style="width: 100px;" placeholder="天" />
                          </el-form-item>
                          <el-form-item label="奖励配置" style="margin-top: 10px;">
                            <Reward :value="p.prize" />
                          </el-form-item>
                          <el-form-item style="margin-top: 10px">
                            <el-button type="danger" size="mini" @click="delDay('weekly', scope.$index, i)">删除</el-button>
                          </el-form-item>
                        </el-row>
                        <el-form-item style="margin-top: 10px">
                          <el-button type="primary" @click="addDay('weekly', scope.$index)">+</el-button>
                        </el-form-item>
                      </el-form>
                    </el-drawer>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-permisaction="['config:signIn:add']" type="primary" @click="add('weekly')">+</el-button>
              <el-button v-permisaction="['config:signIn:add']" style="margin-top: 10px" type="primary" @click="onSubmit('weekly')">保存</el-button>
            </el-tab-pane>
            <el-tab-pane label="进度" name="progress">
              <el-table :data="formData['progress']" border stripe>
                <el-table-column prop="ID" label="ID">
                  <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="等级范围">
                  <template slot-scope="scope">
                    <el-input v-model.number="scope.row.min_level" style="width: 42%;" placeholder="最小等级" />
                    <span style="margin: 0px 2px">-</span>
                    <el-input v-model.number="scope.row.max_level" style="width: 42%" placeholder="最小等级" />
                  </template>
                </el-table-column>
                <el-table-column v-for="(item, index) in process" :key="'progress'+item" :label="'累计'+item+'天'">
                  <template slot-scope="scope">
                    <Reward :value="scope.row.prize_json[index].prize" :read-only="true" />
                  </template>
                </el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[scope.$index].visible = true">配置</el-button>
                    <el-drawer :before-close="(d)=>{return handleClose(d, scope.$index)}" title="奖励配置" size="600px" :visible="visibleArr[scope.$index].visible">
                      <el-form :inline="true">
                        <el-row v-for="(p,i) in scope.row.prize_json" :key="i">
                          <el-form-item label="累计" style="margin-top: 10px;">
                            <el-input v-model.number="p.day" style="width: 100px;" placeholder="天" />
                          </el-form-item>
                          <el-form-item label="奖励配置" style="margin-top: 10px;">
                            <Reward :value="p.prize" />
                          </el-form-item>
                          <!--                          <el-form-item style="margin-top: 10px">-->
                          <!--                            <el-button type="danger" size="mini" @click="delDay('progress', scope.$index, i)">删除</el-button>-->
                          <!--                          </el-form-item>-->
                        </el-row>
                        <!--                        <el-form-item style="margin-top: 10px">-->
                        <!--                          <el-button type="primary" @click="addDay('progress', scope.$index)">+</el-button>-->
                        <!--                        </el-form-item>-->
                      </el-form>
                    </el-drawer>
                  </template>
                </el-table-column>
              </el-table>
              <el-button v-permisaction="['config:signIn:add']" type="primary" @click="add('progress')">+</el-button>
              <el-button v-permisaction="['config:signIn:add']" style="margin-top: 10px" type="primary" @click="onSubmit('progress')">保存</el-button>
            </el-tab-pane>
            <el-tab-pane label="豪华签到" name="super">
              <superSign ref="superSign" />
            </el-tab-pane>
          </el-tabs>
        </template>

      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import {
  delSignInCfg, getSignInCfgList,
  updateSignInCfg
} from '@/api/config/sign-cfg'
import { getRewardType } from '@/api/config/slot'
import { getAnimalAllList, getShieldsAllList, getSieveAllList } from '@/api/config/area-cfg'
import { getChestCfgAll } from '@/api/config/chest-skin-cfg'
import superSign from '@/views/config/sign-in-interval/components/super.vue'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import Reward from '@/components/Reward/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'SignInInterval',
  components: {
    SyncData,
    Reward,
    ClearCacheApply,
    superSign
  },
  data() {
    return {
      days: [1, 2, 3, 4, 5, 6, 7],
      process: [],
      activeName: 'weekly',
      signLevelData: [],
      coinsType: [{
        value: 'coins01'
      }, {
        value: 'coins02'
      }, {
        value: 'coins03'
      }, {
        value: 'coins04'
      }, {
        value: 'coins05'
      }, {
        value: 'coins06'
      }],
      selectType: [
        {
          'id': 1,
          'title': '只取数量'
        },
        {
          'id': 2,
          'title': '等级取值'
        }
      ],
      tableType: [{
        label: '周期',
        value: 'weekly'
      }, {
        label: '进度',
        value: 'progress'
      }],
      rewardType: [],
      visibleArr: [{ visible: false }],
      visibleProgressArr: [{ visible: false }],
      rewardVisibleArr: {
        'weekly': [],
        'progress': []
      },
      formData: {
        weekly: [],
        progress: []
      },
      skinId: [62, 19, 67, 68],
      chessId: [],
      shield: [],
      sieve: [],
      areaId: [],
      rewards: { rewardListBak: [], stageListBak: [], rewardList: {}, stageList: {}}
    }
  },
  created() {
    this.getShieldsId()
    this.getSieveId()
    this.getChessId()
    this.getAreaId()
    this.getRewardTypeData()
    this.getTables(this.activeName)
  },
  methods: {
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    handleRewardClose(d, type, index, i) {
      this.rewardVisibleArr[type][index][i].visible = false
    },
    onSubmit(name) {
      for (const i in this.formData[name]) {
        const _data = this.formData[name][i]
        if (_data.min_level > _data.max_level) {
          this.msgError('低等级不能大于高等级')
          return
        }
        for (const rk in _data.prize_json) {
          const pj = _data.prize_json[rk]
          for (const k in pj.prize) {
            if (pj.prize[k].propsId === 65) {
              this.formData[name][i].prize_json[rk].prize[k].num *= 10000
            }
          }
        }
      }
      const data = JSON.stringify(this.formData[name])
      console.log(data)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
        return
      }
      updateSignInCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables(this.activeName)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables(name) {
      getSignInCfgList({ name: name }).then(res => {
        res.data.forEach((item, index) => {
          for (const rk in item.prize_json) {
            const pj = item.prize_json[rk]
            for (const k in pj.prize) {
              if (pj.prize[k].propsId === 65) {
                res.data[index].prize_json[rk].prize[k].num /= 10000
              }
            }
          }
          this.visibleArr.push({
            visible: false
          })
          this.$set(this.rewardVisibleArr[name], index, [{ visible: false }])
          this.process = []
          item.prize_json.forEach((p, idx) => {
            if (name === 'progress') {
              this.process.push(p.day)
            }
            this.rewardVisibleArr[name][index].push({ visible: false })
          })
        })
        this.formData[name] = res.data
      })
    },
    add(name) {
      this.formData[name].push({
        'id': 0,
        'type': name,
        'min_level': 0,
        'max_level': 0,
        'ss_group': [0],
        'prize_json': [{
          'day': 1,
          'prize': []
        }],
        'other_json': []
      })
      this.visibleArr.push({
        visible: false
      })
      const index = this.formData[name].length - 1
      this.$set(this.rewardVisibleArr[name], index, [{ visible: false }])
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delSignInCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    getRewardTypeData() {
      getRewardType().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.rewardType.push({ 'label': res.data[i], 'value': parseInt(i) })
          }
        }
      })
    },
    handleClick(tab, event) {
      // console.log(tab.name, event)
      this.getTables(tab.name)
      if (tab.name === 'super') {
        this.$refs.superSign.getTables()
      }
    },
    addDay(name, index) {
      const len = this.formData[name][index].prize_json.length
      if (name === 'weekly') {
        if (len > 6) {
          this.msgError('已达上限')
          return
        }
      }
      if (name !== 'weekly') {
        const day = [8, 15, 22, 30]
        for (const i in day) {
          this.formData[name][index].prize_json.push(
            {
              'day': day[i],
              'prize': []
            }
          )
          this.rewardVisibleArr[name][index].push({ visible: false })
        }
      } else {
        this.formData[name][index].prize_json.push(
          {
            'day': len + 1,
            'prize': []
          }
        )
        this.rewardVisibleArr[name][index].push({ visible: false })
      }
    },
    delDay(name, index, i) {
      this.formData[name][index].prize_json = this.formData[name][index].prize_json.filter((item, key) => {
        return i !== key
      })
    },
    addReward(name, index, i) {
      console.log(this.formData[name][index].prize_json[i].day)
      this.formData[name][index].prize_json[i].prize.push({
        propsId: 0,
        skin: 0,
        num: 0,
        rtype: 2
      })
    },
    removeReward(name, index, i, pi) {
      this.formData[name][index].prize_json[i].prize = this.formData[name][index].prize_json[i].prize.filter((res, key) => {
        return key !== pi
      })
    },
    rewardOnSubmit(key, index) {
      this.visibleArr[index].visible = false
      this.onSubmit(key)
    },
    getAreaId() {
      getChestCfgAll().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.areaId.push({ 'label': res.data[i].name, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getChessId() {
      getAnimalAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.chessId.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getShieldsId() {
      getShieldsAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.shield.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    getSieveId() {
      getSieveAllList().then(res => {
        if (res.code === 200) {
          for (const i in res.data) {
            this.sieve.push({ 'label': res.data[i].lang_key, 'value': parseInt(res.data[i].id) })
          }
        }
      })
    },
    propChange(v, name, index, i, pi) {
      const record = this.formData[name][index].prize_json[i].prize[pi]
      const typ = parseInt(v)
      record.num = 1
      switch (typ) {
        case 64:
          record.skin = this.chessId[0].value
          break

        case 19:
          record.skin = this.areaId[0].value
          break
        default:
          record.skin = 0
      }
      this.formData[name][index].prize_json[i].prize[pi] = record
    }, getReward(prize) {
      if (prize === undefined) {
        return '-'
      }
      const str = []
      for (const i in prize.prize) {
        const r = prize.prize[i]
        for (const k in this.rewardType) {
          const rt = this.rewardType[k]
          if (r.propsId === rt.value) {
            str.push(rt.label + '*' + r.num)
          }
        }
      }
      return str.join(',')
    }
  }
}
</script>

<style scoped>
</style>
